// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2f1Eu","title":"FrontImage_title__TyA-5"};